export default {"src":"/_next/static/media/bank-jcb.37aadbc2.svg","height":24,"width":31,"blurWidth":0,"blurHeight":0};